import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, Button, Field, Loading } from "@/components/kit";

export default function Settings() {
  const { user } = useAuth();
  const [notif, setNotif] = useState(null);
  const [pwd, setPwd] = useState({ current: "", next: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.getNotifSettings().then(setNotif).catch(() => setNotif({ class_join: true })); }, []);

  const toggleNotif = async () => {
    const v = !notif.class_join;
    setNotif({ class_join: v });
    try { await api.updateNotifSettings({ class_join: v }); toast.success("Pengaturan disimpan"); }
    catch (e) { toast.error(e.message); }
  };

  const changePwd = async () => {
    if (!pwd.current || pwd.next.length < 6) return toast.error("Password baru minimal 6 karakter");
    setBusy(true);
    try { await api.changePassword(pwd.current, pwd.next); toast.success("Password diperbarui"); setPwd({ current: "", next: "" }); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <div>
      <PageHeader eyebrow="Owner" title="Pengaturan" subtitle="Preferensi notifikasi dan keamanan akun." />

      <div className="grid gap-6 lg:grid-cols-2">
        <Card>
          <div className="mb-4 hsc-label">Notifikasi</div>
          {!notif ? <Loading /> : (
            <label className="flex cursor-pointer items-center justify-between">
              <div>
                <div className="text-sm text-white">Notifikasi saat member join kelas</div>
                <div className="text-[12px] text-[#6E6E73]">Kirim notifikasi ke owner setiap ada pendaftaran kelas baru.</div>
              </div>
              <button onClick={toggleNotif} data-testid="notif-toggle"
                className={`relative h-6 w-11 shrink-0 rounded-full transition-colors ${notif.class_join ? "bg-white" : "bg-[#2C2C2E]"}`}>
                <span className={`absolute top-0.5 h-5 w-5 rounded-full bg-black transition-transform ${notif.class_join ? "translate-x-5" : "translate-x-0.5"}`} />
              </button>
            </label>
          )}
        </Card>

        <Card>
          <div className="mb-4 hsc-label">Akun</div>
          <div className="mb-4 rounded-lg border border-[#1F1F22] bg-[#0E0E10] p-3 text-sm">
            <div className="text-white">{user.name}</div>
            <div className="text-[12px] text-[#6E6E73]">{user.email}</div>
          </div>
          <div className="space-y-4">
            <Field label="Password Saat Ini"><input type="password" className="hsc-input" value={pwd.current} onChange={(e) => setPwd((s) => ({ ...s, current: e.target.value }))} /></Field>
            <Field label="Password Baru"><input type="password" className="hsc-input" value={pwd.next} onChange={(e) => setPwd((s) => ({ ...s, next: e.target.value }))} /></Field>
            <Button onClick={changePwd} disabled={busy} data-testid="change-pwd">Ubah Password</Button>
          </div>
        </Card>
      </div>
    </div>
  );
}
